import moment from 'moment'

/**
 *Date util class used to normalize dates
 * @export
 * @class DateService
 */
export default class DateService {


    /**
     * Takes in date returns back date with time set to 12 noon to avoid time zone change conflicts between UTC/MST etc.
     * @static
     * @param {Date} value
     * @returns Javascript Date
     * @memberof DateService
     */
    static normalizeDateTime(value) {
        //console.log('dateservice.normalizeDateTime')
        let response = null;
       
        try {
            if (value == undefined || value == null) { return null; }
            
            response = moment.utc(value);
            return response;

        } catch (e) {
            return response;
        }
    }

    static dateFilterComparator = (filterLocalDateAtMidnight, cellValue) => {
        const cellDate = moment(cellValue).startOf("day").toDate();

        if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) {
            return 0;
        }

        if (cellDate < filterLocalDateAtMidnight) {
            return -1;
        }

        if (cellDate > filterLocalDateAtMidnight) {
            return 1;
        }
    }
}